<template>
    <div
        class="fashion caculator-container"
        @click="openCaculator('template4')"
        v-if="!info.pricePerMonth"
        :class="{ nodisclosure: info.nodisclosureDes != null || hidePrice }"
    >
        <span class="iconfont icon-caculator">
            <span class="payment-text">{{
                $t('md-detail-info.estPayment')
            }}</span>
        </span>
        <span class="separator"></span>
        <label>
            {{
                $ft.formatCurrency({
                    value: info.nodisclosureDes != null || hidePrice
                        ? '-'
                        : pricePerMonth,
                    noSpace:true,
                    currencySymbol
                })
            }} 
        </label>
        <span>{{ $t('md-detail-info.mo') }}</span>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';

export default {
    i18next: {
        ns: 'md-detail-info'
    },
    inject: ['openCaculator'],
    data: function() {
        return {};
    },
    computed: {
        ...rootMapState(usePageStore, {
            "house": store => store.page?.house || {},
            "currencySymbol": store => store.currency?.symbol
        }),
        ...mapState({
            "info": store => store.listingDetail.info || {},
            "pricePerMonth": store => store.pricePerMonth
        }),
        hidePrice() {
            return (
                !this.house.showListingPrice &&
                !this.house.showSoldPrice &&
                this.info.listingStatus == 'Sold'
            );
        }
    },
    methods: {}
};
</script>
<style lang="scss">
.fashion.caculator-container {
    height: 24px;
    display: flex;
    align-items: center;
    color: white;
    font-size: 14px;
    &.nodisclosure {
        opacity: 0.4;
        .icon-caculator {
            cursor: initial;
        }
    }
    .separator {
        border-right: 1px solid #717990;
        height: 12px;
        width: 0;
        margin: 0px 7px;
    }
    .icon-caculator {
        cursor: pointer;
        color: #8195bd;
    }
    .payment-text {
        font-size: 12px;
        color: #8195bd;
        margin-left: 5px;
    }
}
@media (max-width: 600px) {
    .caculator-container {
        height: 24px;
        padding: 0;
        margin-left: 0;
        display: block;
        text-align: end;
        position: absolute;
        top: 2px;
        right: 0;
        .separator {
            display: none;
        }
        .icon-caculator {
            cursor: pointer;
            display: block;
            color: #8195bd;
            padding-bottom: 13px;
        }
    }
}
</style>
